import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const username = 'user';
const password = 'password';
const token = btoa(`${username}:${password}`);

const axiosInstance = axios.create({
    // baseURL: 'http://localhost:5173', // Replace with your backend URL
});


axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && (error.response.status === 403 || error.response.status === 401)) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;